import secureCookieStorage from '@gerenciatd/next13.utils.secure.local-storage';

export const hanTranscurridoSeisMeses = (desde, hasta) => {
  const seisMesesEnMilisegundos = 6 * 30 * 24 * 60 * 60 * 1000; // Asumiendo meses de 30 días
  return hasta - desde >= seisMesesEnMilisegundos;
}

export const getUserPersistedInfo = () => {
  const secureCookieStorageLib = new secureCookieStorage();
  let persistedInfo2Use = {}
  let persistedInfo = secureCookieStorageLib.getItem('ts');
  if (persistedInfo && persistedInfo.ts) {
      // check de los 6 meses
      const currentDate = Date.now();
      const lastTs = persistedInfo && persistedInfo.ts;
      const checkSeisMeses = hanTranscurridoSeisMeses(lastTs, currentDate);
      if (checkSeisMeses) {
          persistedInfo = {};
          localStorage.removeItem('ts');
      } else {
          persistedInfo2Use = {
              ...persistedInfo,
          }
      } 
  }

  return persistedInfo2Use;
}

/**
 * Comprueba si existe tabId
 * @returns {boolean}
 */
const existsTabId = () => {
  try {
    if (window.sessionStorage) {
      return sessionStorage.getItem('mov_tabID') !== null;
    }
    return null;
  } catch (err) {
    return null;
  }
};

/**
 * Genera un id para la pestaña actual del navegador.
 * @returns {number}
 */
const generateTabId = () => {
  const tabId = Date.now(); // Todo
  try {
    if (window.sessionStorage) {
      sessionStorage.setItem('mov_tabID', tabId);
      return sessionStorage.getItem('mov_tabID');
    }
    return `notSupportedSessionStorage-${tabId}`;
  } catch (err) {
    return `notSupportedSessionStorage-${tabId}`;
  }
};

/**
 * Obtiene el tabId de la pestaña actual.
 * @returns {func}
 */
export const getTabId = () => {
  if (existsTabId()) {
    return sessionStorage.getItem('mov_tabID');
  }
  return generateTabId();
};
const newID = () => {  
    return Math.random().toString(36).substr(2, 9);  
};

export const generatePageId = () => {  
    const uuidArray = []
    for (let i=0; i<6; i++){
      uuidArray.push(newID())
    }
    const res = uuidArray.join('-')
    try {
      window.pageId = res;
    } catch(err) {
      console.log(err);
    }
    return res;
}

export const transformObjectKeysToGaFormat = (object) => {
  let result = {};
  const keys = object ? Object.keys(object) : [];

  keys.forEach(keyName => {
    const newKey = keyName.replace(/-/g, '_');
    const value = object[keyName];
    result[newKey] = value;
  })
  return result;
}


export const extractComponentTagging = (contextObj) => {
  let res = {
    'event_type': contextObj['event_type'],
    'component_name': contextObj['component_name'],
    'component_content': contextObj['component_content'],
    'component_product': contextObj['component_product'],
    'component_perso': JSON.stringify(contextObj['component_perso']),
    'component_variation': contextObj['component_variation'],
  }

  return res;
}

export const extractUserProperties = (contextObj, shouldSendHash) => {
  let res = {
    'context_ga_cookie': shouldSendHash ? contextObj['context-ga-cookie'] : '', // muerte sin cookie
    'user_client': contextObj['user-client'],
    'user_consent_cookie_onetrust': contextObj['user-consent-cookie-onetrust'],
    'user_cuc_fijo_hash': shouldSendHash ? contextObj['user-cuc-fijo-hash'] : '',// muerte sin cookie
    'user_cuc_movil_hash': shouldSendHash ? contextObj['user-cuc-movil-hash'] : '',// muerte sin cookie
    'user_cuc_prepago_hash': shouldSendHash ? contextObj['user-cuc-prepago-hash'] : '',// muerte sin cookie
    'user_id_party_hash': shouldSendHash ? contextObj['user-id-party-hash'] : '',// muerte sin cookie
    'user_ip_hash': shouldSendHash ? contextObj['user-ip-hash'] : '',// muerte sin cookie
    'user_operador_hash': shouldSendHash ? contextObj['user-operador-hash'] : '',// muerte sin cookie
    'user_priority': contextObj['user-priority'],
    'user_telefono_fijo_hash': shouldSendHash ? contextObj['user-telefono-fijo-hash'] : '',// muerte sin cookie
    'user_telefono_movil_hash': shouldSendHash ? contextObj['user-telefono-movil-hash'] : '', // muerte sin cookie
    'user_type': contextObj['user-type'],
  }

  return res;
}

export const extractMainProperties = (contextObj) => {
  let res ={
    'page_name': contextObj['page-name'],
    'page_product_code': contextObj['page-product-code'],
    'page_product_name': contextObj['page-product-name'],
    'page_segment': contextObj['page-segment'],
    'context_page_id': contextObj['context-page-id'],
    'context_seo_meta': contextObj['context-seo-meta'],
    'context_session_id': contextObj['context-session-id'],
    'context_tab_id': contextObj['context-tab-id'],
    'context_url': contextObj['context-url'],
  }

  return res;
}

export const createPageEventObject = (
  data
) => {
  if (!data) {
    return null;
  }

  const { clientIDs, userType: userTypeFromData } = data;

  const {
    event = 'cms-page',
    eventType = '',
    tabId = '',
    pageName = '',
    pageProductCode = '',
    pageProductName = '',
    contextGaCookie = (clientIDs && clientIDs.ga) || null,
    contextSessionId = (clientIDs && clientIDs.sessId) || null,
    contextPageId = (clientIDs && clientIDs.pageId) || null,
    userCUCFijoHash = '',
    userCUCMovilHash = '',
    userCUCPrepagoHash = '',
    userIPHash = '',
    userOperadorHash = '',
    userTelefonoFijoHash = '',
    userTelefonoMovilHash = '',
    userIdPartyHash = '',
    userType = '',
    pageSegment = '',
    contextURL = '',
    userClient = !!userTypeFromData,
    contextSeoMeta = '',
  } = data;

  return {
    event,
    'event-type': eventType,
    'context-tab-id': tabId,
    'page-name': pageName,
    'page-product-code': pageProductCode,
    'page-product-name': pageProductName,
    // client id de ga
    'context-ga-cookie': contextGaCookie,
    // id de sesión de la navegación del usuario
    'context-session-id': contextSessionId,
    // page id de la página
    'context-page-id': contextPageId,
    'user-cuc-fijo-hash': userCUCFijoHash,
    'user-cuc-movil-hash': userCUCMovilHash,
    'user-cuc-prepago-hash': userCUCPrepagoHash,
    'user-ip-hash': userIPHash,
    'user-operador-hash': userOperadorHash,
    'user-telefono-fijo-hash': userTelefonoFijoHash,
    'user-telefono-movil-hash': userTelefonoMovilHash,
    'user-id-party-hash': userIdPartyHash,
    // telco o legado
    'user-type': userType,
    // segmento de navegación de la página
    'page-segment': pageSegment,
    // url de la página
    'context-url': contextURL,
    // true o false si es cliente o no
    'user-client': userClient,
    // meta description de seo
    'context-seo-meta': contextSeoMeta,
  };
};